import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

const  Details = () => {
    const { id } = useParams();
    const [user,setUsers]=useState({})
    const userDetails = () => {

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                // 'Authorization': `Bearer qwertyuiopasdfghjklzxcvbnm123456`, // notice the Bearer before your token
            },
        };
        
        fetch(`https://travelapp-8fhf.onrender.com/location_details/${id}`, requestOptions)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setUsers(data)
        })
    }

    useEffect(() => {
        userDetails();
    });


    const [show,setShow]=useState(false)
    function showPopup(){
        setShow(true);
    }
    function hidePopUp(){
        setShow(false);
    }

    return (
      <>
            {
                user[0] != null ? 

                <section className="featuresDetails details">
                    <picture><img src={user[0].photo[0]} alt="" /></picture>
                    
                    <article>
                        <h1>{user[0].name}
                        {/* <small>{user.details}</small> */}
                        </h1>
                        <button className="detailsBttn" onClick={showPopup}>More Details</button>
                    </article>

                        <div className="thumbImagesScroll">
                            {user[0].photo.map(element => ( 
                                <img src={element} alt="" />
                            ))} 
                        </div>

        

                        <span>
                            <img src="" alt="" />
                        </span>

                    <span>
                        <img src={user.photo} alt="" />
                    </span>
                    {
                        show?<div className="detailsPopWrap">
                            <div className="detailsPopContent">
                                <h2>{user[0].name}</h2>
                                <p>{user[0].desc}</p>
                            </div>
                            <span className="detailsPopClose" onClick={hidePopUp}></span>
                        </div>:null
                    }
                    
                </section> : null

            }

              
      </>
    );
  }
  
  export default Details;